export const colors = {
    customBlack: '#1C1C1C',
    ansText: '#8D8D8D',
    skyBlue: 'orange',
    darkSkyBlue: '#06527a',
    green: '#098A04',
    yellow: '#FBBC12',
    lightSilver: '#D1DADF',
    lightSkyBlue: '#FB7A01',
    modalBackground: 'rgba(0,0,0,0.5)',
    lightGreen: '#3AD69E',
    darkBlue: '#003450',
    tomato: 'tomato',
    textDarkGrey: '#6E6E6E',
    black: '#000000',
    white: '#FFFFFF',
    silver: '#b6b6b6',
    red: '#FF2929',
    orange:"#FB7A01"
  };
  